import React from 'react'
import Grid, { GridSpacing } from '@material-ui/core/Grid'
import {
  DynamicCheckboxOption,
  DynamicDateField,
  DynamicRadioGroup,
  DynamicTextField,
  DynamicFormGroup
} from './interfaces/Form'
import DynamicField from './DynamicField'
import { Theme } from '@material-ui/core/styles'

interface DynamicFieldsProps {
  fields: (
    | DynamicCheckboxOption
    | DynamicRadioGroup
    | DynamicFormGroup
    | DynamicTextField
    | DynamicDateField
  )[]
  index?: number
  fullWidth?: boolean
  gridSpacing?: GridSpacing
  useStyles: any
  fieldSuggestedResponses?: any
  theme: Theme
}

const DynamicFields: React.FC<DynamicFieldsProps> = ({
  fields,
  index = -1,
  gridSpacing,
  useStyles,
  fieldSuggestedResponses,
  theme
}) => {
  return (
    <React.Fragment>
      {fields.map(
        (
          field:
            | DynamicCheckboxOption
            | DynamicRadioGroup
            | DynamicFormGroup
            | DynamicTextField
            | DynamicDateField
        ) => {
          const key = index > -1 ? `${field.key}-${index}` : field.key
          return (
            <DynamicField
              key={key}
              field={field}
              index={index}
              fullWidth={field.fullWidth}
              useStyles={useStyles}
              keyName={key}
              allSuggestedResponses={fieldSuggestedResponses}
              theme={theme}
            />
          )
        }
      )}
    </React.Fragment>
  )
}

export default DynamicFields
